/**
 * Admin utilities - client-safe
 */

/**
 * Admin email whitelist
 */
export const ADMIN_EMAILS = [

  'marcus@antengo.com',
  'nick@antengo.com',
  'ryan@antengo.com',

  'john@antengo.com',
  'jonathan@antengo.com',
  'tom@antengo.com',
  'alejandro@antengo.com',

  'lawrence@antengo.com',
  'law@cinemasetfree.com'
];

/**
 * Check if an email is an admin email
 */
export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email);
}

/**
 * Is this one of the staff addresses -- an admin or the sysop -- in any case?
 *
 * `isAdminEmail` is exact on purpose: it gates a session, whose email is the
 * account's own. This guards the doors that FIND or CREATE an account from an
 * address someone typed or a partner sent, and those lookups ignore case, so
 * this must too.
 */
export function isStaffEmailAddress(email: string | null | undefined): boolean {
  if (!email) return false;
  const given = email.trim().toLowerCase();
  return given === SYSOP_EMAIL.toLowerCase() || ADMIN_EMAILS.some((admin) => admin.toLowerCase() === given);
}

/**
 * Sysop email - highest privilege level, single user
 */
export const SYSOP_EMAIL = 'lawrence@antengo.com';

/**
 * Check if an email is the sysop email
 */
export function isSysopEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return email === SYSOP_EMAIL;
}
